











import { defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'

import { useProductStore } from '~/store/product'

import { PRODUCT_STATUS } from '@/common/utils/product/constants'
import { DEVKEY } from '@/common/constants/cms'
import ContentTargeter from '~/components/global/targeters/ContentTargeter.vue'

export default defineComponent({
  components: {
    ContentTargeter,
  },
  setup() {
    const { currentProduct } = useProductStore()

    const productStatus = currentProduct.data.attributes.statusDates.status
    const orderingDetails = currentProduct.data.attributes.orderingDetails

    const isProductDiscontinued = productStatus === PRODUCT_STATUS.DISCONTINUED
    const orderingDetailsRenderingCondition = !isEmpty(orderingDetails) && !isProductDiscontinued

    return {
      isProductDiscontinued,
      orderingDetails,
      orderingDetailsRenderingCondition,
      isEmpty,
      DEVKEY,
    }
  },
})
